import React, { useState } from "react";
import './style.css';
import ShowMoreIcon from '../../assets/icons/ShowMoreIcon.svg';

export const HyperlinkParagraph = ({ text, readMoreLength = 150 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const paragraph = text;

  // Regular expression patterns
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

  // Function to replace matched URLs with anchor tags
  const replaceURLsWithLinks = (text) =>
    text?.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);

  // Function to replace matched emails with mailto links
  const replaceEmailsWithLinks = (text) =>
    text?.replace(emailRegex, (email) => `<a href="mailto:${email}">${email}</a>`);

  // Function to format the paragraph with links and emails
  const formatParagraph = (text) => {
    const formattedText = text?.replace(/</g, '\n<');
    const paragraphWithLinks = replaceURLsWithLinks(formattedText);
    const paragraphWithLinksAndEmails = replaceEmailsWithLinks(paragraphWithLinks);

    return paragraphWithLinksAndEmails;
  };

  const formattedParagraph = formatParagraph(paragraph);

  const handleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <div>
      <div
        className={`paragraph-container ${isExpanded ? 'expanded' : ''}`}
        dangerouslySetInnerHTML={{ __html: formattedParagraph }}
      />
      {formattedParagraph?.length > readMoreLength && (
        <div onClick={handleReadMore} className="read-or-hide" style={{ color: "#4054B2", fontWeight: '600' }}>
          {isExpanded ? 'Read Less' : <>Show more <img src={ShowMoreIcon} alt="show-more-icon" /></>}
        </div>
      )}
    </div>
  );
};
